<template>
  <div class="clock">
    <div id="Date"></div>
    <ul>
      <li id="hours">{{getTime().hours}}</li>
      <li id="point">:</li>
      <li id="min">{{getTime().minutes}}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "currentTime",
  methods: {
    getTime() {
      const today = new Date();

      return {
        hours: today.getHours(),
        minutes: today.getMinutes()
      }
    }
  }
}
</script>

<style scoped>

</style>
